const HUB_THEME_ATTRIBUTE = 'data-theme';
const HUB_DEFAULT_THEME = 'light';

/** Clears document-level layout side effects left by embedded sub-apps (overflow locks, height chain). */
function resetHubDocumentLayout(): void {
	const app = document.getElementById('app');
	const elements = [document.documentElement, document.body, app].filter(
		(element): element is HTMLElement => element instanceof HTMLElement,
	);

	for (const element of elements) {
		element.style.removeProperty('transform');
		element.style.removeProperty('zoom');
		element.style.removeProperty('max-width');
		element.style.removeProperty('min-width');
		element.style.removeProperty('margin');
		element.style.removeProperty('height');
		element.style.removeProperty('min-height');
		element.style.removeProperty('max-height');
		element.style.width = '100%';
		element.style.maxWidth = 'none';
	}

	document.body.style.removeProperty('overflow');
}

export function normalizeHubTheme(): void {
	if (typeof document === 'undefined') {
		return;
	}

	document.documentElement.setAttribute(HUB_THEME_ATTRIBUTE, HUB_DEFAULT_THEME);
	resetHubDocumentLayout();
}
